import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import Box from '@nubank/nuds-web/components/Box/Box';
import { FormattedMessage } from 'react-intl';

import { StyledImage } from '../styles/StyledImage';

function SectionCareers() {
  return (
    <Box
      tag="section"
      paddingVertical={{ xs: '3x', md: '20x', lg: '12x' }}
      paddingHorizontal={{ xs: '3x', md: '12x', lg: 195 }}
      backgroundColor="white.dark"
    >
      <Box
        display={{ md: 'flex' }}
        alignItems={{ md: 'center' }}
        backgroundColor="white.default"
      >
        <Box
          flex={{ md: '1 0 0' }}
        >
          <StyledImage
            loading="lazy"
            srcSet={{
              xs: 'man-sitting-with-notebook/man-sitting-with-notebook@xs-2x.jpg',
              md: 'man-sitting-with-notebook/man-sitting-with-notebook@md-2x.jpg',
              lg: 'man-sitting-with-notebook/man-sitting-with-notebook@lg-2x.jpg',
            }}
            altIntlKey="ABOUT_US.CAREERS.IMAGE_ALT"
          />
        </Box>
        <Box
          flex={{ md: '1 0 0' }}
          paddingVertical={{ xs: '16x', md: '0x' }}
          paddingHorizontal={{ xs: '8x', md: '16x' }}
          backgroundColor="white.default"
        >
          <Typography
            variant="title"
            color="black"
            colorVariant="default"
            gutterBottom={2}
            maxWidth="18rem"
            intlKey="ABOUT_US.CAREERS.TITLE"
          />
          <Typography
            variant="paragraph2"
            color="black"
            colorVariant="default"
            gutterBottom={1}
            maxWidth={{ lg: '24rem' }}
            intlKey="ABOUT_US.CAREERS.TEXT"
          />
          <FormattedMessage id="CAREERS.GREENHOUSE_LINK">
            {([greenhouseLink]) => (
              <Link
                color="primary"
                variant="action"
                href={greenhouseLink}
                intlKey="ABOUT_US.CAREERS.LINK"
              />
            )}
          </FormattedMessage>
        </Box>
      </Box>
    </Box>
  );
}

export default React.memo(SectionCareers);
